import bem from 'utils/bem';

export const block = bem('transcription-form');
